export var DocumentVisibilityStatus;
(function (DocumentVisibilityStatus) {
    DocumentVisibilityStatus["PRIVATE"] = "PRIVATE";
    DocumentVisibilityStatus["SELECTED"] = "SELECTED";
    DocumentVisibilityStatus["PUBLIC"] = "PUBLIC";
})(DocumentVisibilityStatus || (DocumentVisibilityStatus = {}));
export var ContentTypeEnum;
(function (ContentTypeEnum) {
    ContentTypeEnum["ABOUT_BLOCK"] = "ABOUT_BLOCK";
    ContentTypeEnum["FEEDBACK_BLOCK"] = "FEEDBACK_BLOCK";
    ContentTypeEnum["IMPACT_FACTS_BLOCK"] = "IMPACT_FACTS_BLOCK";
    ContentTypeEnum["MORE_INFO_BLOCK"] = "MORE_INFO_BLOCK";
    ContentTypeEnum["PRODUCTS_BLOCK"] = "PRODUCTS_BLOCK";
    ContentTypeEnum["PRODUCT_JOURNEY_BLOCK"] = "PRODUCT_JOURNEY_BLOCK";
    ContentTypeEnum["VERIFIED_PAYMENT_BLOCK"] = "VERIFIED_PAYMENT_BLOCK";
    ContentTypeEnum["IMPACT_CLAIMS"] = "IMPACT_CLAIMS";
    ContentTypeEnum["MAIN_SCREEN"] = "MAIN_SCREEN";
})(ContentTypeEnum || (ContentTypeEnum = {}));
export var MapType;
(function (MapType) {
    MapType["DEFAULT"] = "DEFAULT";
    MapType["LIMITED_LINKS"] = "LIMITED_LINKS";
})(MapType || (MapType = {}));
export var PinTarget;
(function (PinTarget) {
    PinTarget["MAP"] = "MAP";
    PinTarget["NODE"] = "NODE";
})(PinTarget || (PinTarget = {}));
